export default __webpack_public_path__ + "06391c6d45936117c9df662c0a9e45b7.png";